import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import type { MouseEvent } from "react";

interface Props {
  onClick: (e?: MouseEvent) => void;
}

export default function ChartDownloadPngButton({ onClick }: Props) {
  return (
    <button
      type="button"
      className="chart-tool-btn"
      title="Download as PNG"
      aria-label="Download as PNG"
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      <FileDownloadOutlinedIcon fontSize="small" />
    </button>
  );
}
